import React, { Component } from "react";
import { connect } from "react-redux";
import { UpdatePayment } from "../../../../redux/actions/Cart.Action";

import fonepay from "../../../../assets/img/payment/Fonepay.png";
import khalti from "../../../../assets/img/payment/Khalti.png";
import smartqr from "../../../../assets/img/payment/smartqr.png";

import { QRCode } from "react-qrcode-logo";
import ApiConnect from "../../../../Utils/ApiConnect";
import scan from "../../../../assets/img/payment/scan.svg";
import qrsuccess from "../../../../assets/img/payment/qrsuccess.svg";
import loading from "../../../../assets/img/loading.svg";
class EWallet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      qrmsg: false,
      qrimage: scan,
      message: "",
      Ewallet: "",
      wimage: false,
    };
  }
  WalletOption(opt) {
    this.props.UpdatePayment(opt, this.props.CurrentCart.total, "");
    this.setState({ qrimage: loading, qrmsg: "", Ewallet: opt });
    switch (opt) {
      case "Khalti":
        this.handle_Khalti(this.props.order_id);
        this.setState({ wimage: khalti });
        break;
      case "Fonepay":
        this.handle_Fonepay(this.props.order_id);
        this.setState({ wimage: fonepay });
        break;
      case "smartqr":
        this.setState({ wimage: smartqr });
        this.handle_Khalti(this.props.order_id);
        break;
      default:
        break;
    }
  }
  handle_Fonepay(order) {
    ApiConnect.get("POS/Checkout/FonepayQR?orderid=" + order)
      .then((response) => {
        if (response.data.status === 201) {
          // console.log(response.data)
          if (response.data.socket) {
            this.RealTimeSocket(response.data.socket);
          }
          this.setState({
            khaltiopt: false,
            fonepayopt: true,
            qrmsg: response.data.qrMessage,
          });
        } else if (response.data.status === 202) {
          this.setState({ qrmsg: "", qrimage: qrsuccess, message: "" });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  handle_Khalti(order) {
    ApiConnect.get("POS/Checkout/KhaltiQR?orderid=" + order)
      .then((response) => {
        if (response.data.status === 201) {
          this.setState({ qrmsg: response.data.message });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  RealTimeSocket(url) {
    const client = new WebSocket(url);
    client.onopen = (e) => {
      console.log(e);
    };
    client.onerror = (e) => {
      console.log(e);
    };
    client.onmessage = (e) => {
      console.log("socken message");
      const data = JSON.parse(e.data);
      let Status = JSON.parse(data.transactionStatus);
      if (Status.paymentSuccess) {
        this.setState({
          qrimage: qrsuccess,
          qrmsg: "",
          message: "Received " + Status.totalCalculatedAmount,
        });
        this.props.OtherPayment(
          this.state.Ewallet,
          Status.totalCalculatedAmount,
          Status.traceId
        );
        this.Payment_Verified(
          "Fonepay",
          Status.totalCalculatedAmount,
          Status.traceId
        );
      }
      if (Status.qrVerified) {
        this.setState({ qrimage: loading, qrmsg: "" });
      }
    };
  }
  Payment_Verified(type, amount, tid) {
    ApiConnect.put(
      `POS/Checkout/PaymentDone?orderid=${this.props.order_id}&type=${type}&amount=${amount}&tid=${tid}`
    )
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  render() {
    return (
      <div className="card mb-0">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6 br-1">
              <div className="row">
                <h4 className="col-6">E-Wallet Options </h4>
                <h4 className="col-6">Total {this.props.total} </h4>
              </div>
              <label
                className="col m-2 btn btn-w-lg btn-outline btn-multiline"
                onClick={(e) => this.WalletOption("Fonepay")}
              >
                <img src={fonepay} width="150" alt="Fonepay" />
              </label>
              <label
                className="col m-2 btn btn-w-lg btn-outline btn-multiline"
                onClick={(e) => this.WalletOption("Khalti")}
              >
                <img src={khalti} width="150" alt="Khalti" />
              </label>
              <label
                className="col m-2 btn btn-w-lg btn-outline btn-multiline"
                onClick={(e) => this.WalletOption("smartqr")}
              >
                <img src={smartqr} width="150" alt="Smart QR" />
              </label>
            </div>
            <div className="col-md-6 br-1 text-center">
              <figure className="figure img-thumbnail pb-5">
                {this.state.qrmsg ? (
                  <QRCode
                    value={this.state.qrmsg}
                    size="250"
                    qrStyle="dots"
                    logoHeight={50}
                    eyeRadius={50}
                  />
                ) : (
                  <img src={this.state.qrimage} width="250" alt="default" />
                )}
                <figcaption className="figure-caption text-center">
                  {this.state.message ? this.state.message : ""}{" "}
                  {this.state.wimage ? (
                    <img
                      src={this.state.wimage}
                      width="50"
                      alt={this.state.Ewallet}
                    />
                  ) : (
                    ""
                  )}
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({ CurrentCart: state.Cart.CurrentCart }), {
  UpdatePayment,
})(EWallet);
